const PUBLIC_AUTH_ENDPOINTS = [
  '/accounts/login',
  '/accounts/login-2fa',
  '/accounts/refresh-token',
  '/accounts/register',
  '/accounts/forget-password',
  '/accounts/reset-password',
  '/otp/send-without-token',
  '/otp/validate-without-token',
];

const AUTH_RECOVERY_EXCLUDED_ENDPOINTS = [
  ...PUBLIC_AUTH_ENDPOINTS,
  '/accounts/logout',
];

export function shouldSkipAuthorization(url: string): boolean {
  return PUBLIC_AUTH_ENDPOINTS.some(endpoint => url.includes(endpoint));
}

export function shouldSkipAuthRecovery(url: string): boolean {
  return AUTH_RECOVERY_EXCLUDED_ENDPOINTS.some(endpoint => url.includes(endpoint));
}
